export const DASHBOARD_CONFIG = {
    // Search
    SEARCH_DEBOUNCE_MS: 300,

    // Pagination
    DEFAULT_PER_PAGE: 10,
    MAX_PER_PAGE: 50,

    // Limits
    MAX_ITEMS_PER_COLLECTION: 500,
    SIZE_WARNING_THRESHOLD: 0.9,

    // Performance
    VIRTUAL_SCROLL_THRESHOLD: 50,
    CACHE_DURATION_MS: 5 * 60 * 1000, // 5 minutes

    // Networking
    API_TIMEOUT_MS: 30_000,
    RETRY_DELAY_MS: 1_000,
    MAX_RETRIES: 3,
};
